module.exports = __webpack_public_path__ + "static/media/imgNavegadores.e07468e6.png";